import { render, staticRenderFns } from "./ElectionResultList.vue?vue&type=template&id=ec814aac&scoped=true"
import script from "./ElectionResultList.vue?vue&type=script&lang=js"
export * from "./ElectionResultList.vue?vue&type=script&lang=js"
import style0 from "./ElectionResultList.vue?vue&type=style&index=0&id=ec814aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec814aac",
  null
  
)

export default component.exports